export const modes = [
    {value: 'CONV_ORGANISATION', title: 'Conveyancing Organisation'},
    {value: 'CONV_BRANCH', title: 'Conveyancing Branch'},
    {value: 'EA_ORGANISATION', title: 'Estate Agency organisation'},
    {value: 'EA_BRANCH', title: 'Estate Agency branch'},
    {value: 'MORTGAGE_USER', title:'Mortgage Broker' }
];
